import { useNavigate } from 'react-router';
import { storageKey, SearchCategory } from '@/components/Hypertracker/HyperSearch/hypersearchTypes';
import { SearchResultEntry } from './unifiedSearchTypes';

interface LastSearchEntry {
    type: SearchCategory;
    url: string | null;
    label: string;
    timestamp: number;
}

export const saveLastSearch = ({
    type,
    url,
    label,
}: {
    type: SearchCategory;
    url: string | null;
    label: string;
}) => {
    const timestamp = new Date().getTime();
    const lastSearch = localStorage.getItem(storageKey);
    const lastSearchParsed: LastSearchEntry[] = lastSearch ? JSON.parse(lastSearch) : [];
    const isExist = lastSearchParsed.find((item) => item.label === label);

    if (isExist) {
        lastSearchParsed.splice(lastSearchParsed.indexOf(isExist), 1);
    }
    lastSearchParsed.push({ type, url, label, timestamp });

    if (lastSearchParsed.length > 3) {
        lastSearchParsed.shift();
    }
    localStorage.setItem(storageKey, JSON.stringify(lastSearchParsed));
};

export const useSearchRowNavigate = (onAfterSelect?: () => void) => {
    const navigate = useNavigate();

    const onResultClick = (entry: SearchResultEntry) => {
        saveLastSearch({ type: entry.group, url: entry.url, label: entry.displayValue });
        onAfterSelect?.();

        setTimeout(() => {
            navigate(entry.url);
        }, 200);
    };

    return { onResultClick };
};
